// extracted by mini-css-extract-plugin
export var accordion = "styles-module--accordion--fd852";
export var accordionTitle = "styles-module--accordionTitle--b052a";
export var active = "styles-module--active--c80d6";
export var bodyContent = "styles-module--bodyContent--b4828";
export var bodySection = "styles-module--bodySection--b371f";
export var tableWrapper = "styles-module--table-wrapper--0890b";